export default __webpack_public_path__ + "static/media/80b08ec4a5d88091d8d439b19de0bd411576163754077.1fbefda2.webp";